/* v46 (15/10/2026) : copie de v43 sous un NOM NEUF, phrase au-delà de 10 paires en pt et pl. */
/* v43 (14/10/2026) : copie de mix-match-bundle-v41.js sous un NOM NEUF (CDN). Une seule grille pour toute la boutique
   (-20 % dès 3 paires, -30 % dès 5, -40 % dès 7, -50 % dès 10) : le composeur lit product_json jusqu'à 10 paires
   (avant 8), n'affiche aucune remise tant que le palier est à 0 % (1 et 2 paires), et calcule chaque prix comme
   Shopify : la remise se retire PAIRE PAR PAIRE, arrondie au centime inférieur (prix - floor(prix x taux)).
   v41 (13/10/2026) : copie de mix-match-bundle.js sous un NOM NEUF (CDN), seule la phrase au-delà de 8 paires change. */
/* v43 : prix d'une paire au taux pct (en %), en centimes, arrondi comme Shopify (mesuré au vrai panier le 13/10). */
function mmPrixPaire(centimes, pct) {
  centimes = Math.round(centimes || 0);
  return centimes - Math.floor(centimes * (pct || 0) / 100);
}
function scroll_trgger_function(element) {
  /* Le clic sur un onglet doit amener AU TITRE de la collection, pas dessous.
     Demandé par Nicolas le 2026-09-20.

     Avant : un décalage de 70 px écrit en dur. Or deux barres sont collantes et se
     superposent, l'en-tête (73 px sur ordinateur, 65 px sous 990 px) et la barre
     d'onglets elle-même, qui se colle sous lui. Le titre atterrissait donc derrière
     elles. On MESURE la hauteur réellement occupée au moment du clic plutôt que de
     deviner un chiffre qui devient faux au premier changement de gabarit. */
  const barre = document.querySelector('.mix-top-bar');
  let decalage = 16; // respiration sous la barre
  if (barre) {
    const colle = parseFloat(getComputedStyle(barre).top) || 0;
    decalage += colle + barre.getBoundingClientRect().height;
  }
  const yPosition = element.getBoundingClientRect().top + window.pageYOffset - decalage;

  window.scrollTo({
    top: yPosition,
    behavior: 'smooth'
  });

}

function add_active_class(element) {
    // console.log(element);
    const ischck = element.getAttribute('data-add-class') || null;
  // console.log("ischck",ischck);
    if(ischck){
      const getallele = element.parentElement.parentElement || null;
      // console.log("!getallele",getallele);
      if(!getallele) return
      const allele = getallele.querySelectorAll('[data-add-class]') || null; 
      if(allele.length > 0){
           allele.forEach(element_loop => {
             element_loop.classList.remove(ischck);
           });
        element.classList.add(ischck);
        
      }
    }
  
}
(function() {
const scroll_element = document.querySelectorAll('[data-click]') || null;
  if(scroll_element.length > 0){
      scroll_element.forEach(button => {
        button.addEventListener('click', function (event) {
         event.preventDefault();
        const targetElement = document.querySelector(`[data-scroll-element='${this.getAttribute('data-click')}']`) || null;
          if (targetElement) {
            scroll_trgger_function(targetElement);
          }
          add_active_class(this);
        });
      });
  }
})();


class QuantityInputMax extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.gift_box = document.querySelector("[data-bundle-main]") || null;
    this.progreshbar = document.querySelectorAll('.product_update_progress ul li') || null;
    this.datadefualtblock = document.querySelector('[data-defualt-zero]') || null; 
    this.datacheangblock = document.querySelector('[data-defualt-all]') || null; 
    this.datanexdis = document.querySelector('[data-next-discount]') || null; 
    this.buttomtext = document.querySelector('[data-buttom-text]') || null; 
   


    
    // this.input.addEventListener("change", (e) => {
    //         this.updateHtml(e);
    //       });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    if(!this.getAttribute('data-gift-selector') == true ){
        this.updateHtml(this)
      }else{
      this.updatecontent(this);
      }
      
  }
updateHtml(event){

 
   const discount = 0;
      const productId = this.getAttribute("product-var-id");
      const producttitle_main = this.getAttribute("product-title");
      const varisnttitle = this.getAttribute("product-variant");
      const productImage = this.getAttribute("product-image");
      const productprice = this.getAttribute("product-price");
      const discountprice = productprice * discount;
      const this_input_test = this.querySelector('input').value;
   const producttitle = `${producttitle_main} - ${varisnttitle}`;
      let existingItem = document.querySelector(`product-card-gift[product-card-gift-id="${productId}"]`) || null;
  if(this.input.value == 0){
      if (existingItem) existingItem.remove();
  }else{
      if (existingItem) {
        // Update quantity
        existingItem.querySelector('input[name="quantity"]').value = this.input.value;
      } else {
        // Create new cart item   
         const item = `<product-card-gift class="class="main-bundle-wapper" product-card-gift-id="${productId}"><div class="bundle-image-wapper"> <img src="${productImage}" alt="${producttitle}"> </div> <div class="bundle-info">  <div class="bundle-title"> ${producttitle}  </div> <div class="bundle-price-qty-wapper">  <div class="bundle-price" data-update-price> <div main-price-bundle>  <span data-main-price-bundle-update> ${ theme.Currency.formatMoney(productprice * this.input.value, theme.settings.moneyFormat)} </span> <span data-discount-bundle></span></div> <div data-discount-price data-sale-price-bundle-update data-base-price="${productprice}"></div> </div> <div class="bundle-qty"> <quantity-input-mix-match class="quantity" data-gift-selector="true" product-var-id="${productId}" product-price="${productprice}"> <button class="quantity__button no-js-hidden" name="minus" type="button"> <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2"> <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"> </svg> </button> <input class="quantity__input" type="number" name="quantity" id="Quantity-${productId}" data-varadd-id="${productId}" min="0" value="${this.input.value}" > <button class="quantity__button no-js-hidden" name="plus" type="button"> <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"> </svg> </button> </quantity-input-mix-match> </div> </div> </div> </div> </product-card-gift>`;
         const wrapper = document.createElement("div");
         wrapper.innerHTML = item;  
        
        if(this.gift_box) this.gift_box.querySelector(".quantity_lists").appendChild(wrapper.firstElementChild);        
      }
  }

        this.tottal_qtu = this.getTotalQtyCheck();        
         if(this.gift_box){
           this.count_all = this.gift_box.querySelectorAll('[data-count-bundle]') || null;

           this.count_all.forEach(count => {
              count.innerHTML = this.tottal_qtu;
          });
         } 
        this.progreshbar.forEach((bar, index) => {
            if (index <= this.tottal_qtu - 1) {
              bar.classList.add('active');
            } else {
              bar.classList.remove('active');
            }
          });
}

updatecontent(event){
      const productId = this.getAttribute("product-var-id");
      let existingItem = document.querySelector(`.mix-bundle-left [product-var-id="${productId}"]`) || null;

  if(this.input.value == 0){
      this.closest('product-card-gift').remove();
  }
   if (existingItem) {
        existingItem.querySelector('input[name="quantity"]').value = this.input.value;
      }

    this.tottal_qtu = this.getTotalQtyCheck();
         if(this.gift_box){
           this.count_all = this.gift_box.querySelectorAll('[data-count-bundle]') || null;

           this.count_all.forEach(count => {
              count.innerHTML = this.tottal_qtu;
          });
         } 
          // this.main_price_sale.forEach(Priceselector => {
          //     Priceselector.classList.add('discount-added');
          //     Priceselector.innerHTML = theme.Currency.formatMoney(discountprice, theme.settings.moneyFormat);
          // });
        this.progreshbar.forEach((bar, index) => {
            if (index <= this.tottal_qtu - 1) {
              bar.classList.add('active');
            } else {
              bar.classList.remove('active');
            }
          });
}
  
  getTotalQtyCheck() {
     this.bundialdiscount = document.querySelectorAll("[data-discount-bundle]") || null;
    this.main_price_sale = document.querySelectorAll('[data-sale-price-bundle]') || null;
  const total = Array.from(document.querySelectorAll('product-card-gift input[name="quantity"]'))
    .reduce((sum, input) => sum + parseInt(input.value || 0, 10), 0);
    if(!total == 0){
      
      if(total <= 10){
          this.datadefualtblock.classList.add("custom-hide");
          if(product_json[total].topboximage) this.datacheangblock.querySelector('img').src = product_json[total].topboximage;
          if(product_json[total].topbox) this.datacheangblock.querySelector('.order_list_text').innerHTML = product_json[total].topbox;
          if(product_json[total].bottamtext) this.buttomtext.innerHTML = product_json[total].bottamtext;
          if(product_json[total].buttomdis) this.datanexdis.innerHTML = `-${product_json[total].buttomdis}`;

          if(product_json[total].discount){
             /* v43 : à 1 et 2 paires le palier est à 0 % : rien à afficher, comme à 1 paire avant. */
             const pctTotal = parseInt(product_json[total].discount.replace('%',''), 10) || 0;
             const sansRemise = total <= 1 || pctTotal === 0;
             this.bundialdiscount.forEach(discount => {
                    discount.innerHTML = `-${product_json[total].discount}`;
               if(sansRemise) discount.innerHTML ='';
                });

                      this.main_price_sale.forEach(Priceselector => {
                          Priceselector.classList.add('discount-added');
                        const base_price = parseInt(Priceselector.getAttribute('data-base-price'));
                          Priceselector.innerHTML = theme.Currency.formatMoney(mmPrixPaire(base_price, pctTotal), theme.settings.moneyFormat);
                        if(sansRemise){
                          Priceselector.classList.remove('discount-added');
                          Priceselector.innerHTML = '';
                        } 
                      });
           }
        
          if(total == 10) this.datanexdis.innerHTML = '';
      }else{
       /* ⚠️ CETTE PHRASE ETAIT ECRITE EN DUR, EN DEUX LANGUES, DANS UNE BALISE <font>.
          Nicolas, 21/09/2026 : « il y a un bug, il y a ecrit 13 LE ». Le theme collait
          « le » au nombre pour fabriquer un ordinal francais, ce qui donne « 13le produit ».
          Trois defauts d un coup : l ordinal invente, le mot « produit » alors que tout le
          reste du site dit « paire », et l anglais servi a un visiteur allemand ou espagnol
          puisque seules deux langues etaient prevues.
          On passe donc par la langue de la page, on dit « paire », et l ordinal n est plus
          fabrique : au-dela de la grille des paliers, ce qui compte est le nombre a
          ajouter, pas le rang du produit. */
       var lg = (document.documentElement.lang || 'en').slice(0, 2);
       var PHRASES = {
         fr: 'Toujours <b>-50 %</b> sur chaque paire ajoutée',
         en: 'Still <b>-50%</b> on every extra pair',
         de: 'Weiterhin <b>-50 %</b> auf jedes weitere Paar',
         es: 'Sigue el <b>-50 %</b> en cada par que añadas',
         it: 'Sempre <b>-50 %</b> su ogni paio aggiunto',
         nl: 'Nog steeds <b>-50%</b> op elk extra paar',
         pt: 'Continua <b>-50%</b> em cada par extra',
         pl: 'Nadal <b>-50%</b> na każdą kolejną parę'
       };
       /* v41 : la page peut fournir sa propre phrase (product_json.au_dela, v43 : « toujours -50 % »), sinon celle-ci. */
       this.datacheangblock.querySelector('.order_list_text').innerHTML = (product_json.au_dela) || PHRASES[lg] || PHRASES.en;
      }
    }else{
      this.datadefualtblock.classList.remove("custom-hide");
      if(product_json[1].topboximage) this.datacheangblock.querySelector('img').src = product_json[1].topboximage;
      if(product_json[1].topbox) this.datacheangblock.querySelector('.order_list_text').innerHTML = product_json[1].topbox;
      if(product_json[1].bottamtext) this.buttomtext.innerHTML = product_json[1].bottamtext;
      if(product_json[1].buttomdis) this.datanexdis.innerHTML = product_json[1].buttomdis;
     if(product_json[1].discount){
       this.bundialdiscount.forEach(discount => {
              // discount.innerHTML = `-${product_json[1].discount}`;
                discount.innerHTML ='';
          });

           this.main_price_sale.forEach(Priceselector => {
                          Priceselector.classList.remove('discount-added');
                          Priceselector.innerHTML = '';
                      });
       
     }
    }

    const total_price = document.querySelectorAll("[data-gift-selector='true']") || null;
    const cart_main_price = document.querySelector("[add-cart-main-price]") || null;
    const cart_comper_price = document.querySelector("[add-cart-compate-price]") || null;
    /* v43 : remise du pack au-delà de 10 paires = celle de 10 (le meilleur palier). */
    const cle = (total <= 10 && total > 0) ? total : 10;
    const pctPack = parseInt(String(product_json[cle].discount || '0').replace('%',''), 10) || 0;
    let countprice = 0, countnet = 0;
      if(total_price.length > 0){
          total_price.forEach(price => {
              const qty = parseInt(price.querySelector("input[name='quantity']").value || 0, 10);
              const unite = parseInt(price.getAttribute('product-price'));
              const pricecount = unite * qty;
              /* Prix net = (prix de la paire moins sa remise arrondie au centime inférieur) x quantité, comme Shopify. */
              const netcount = mmPrixPaire(unite, pctPack) * qty;
              const main_ele = price.closest('product-card-gift').querySelector('[data-main-price-bundle-update]') || null;
              const main_ele_dis = price.closest('product-card-gift').querySelector('[data-sale-price-bundle-update]') || null;
              if(main_ele)main_ele.innerHTML = theme.Currency.formatMoney(pricecount, theme.settings.moneyFormat);
             if(main_ele_dis && (total <= 1 || pctPack === 0)){
               main_ele_dis.innerHTML = '';
             }
            else if(main_ele_dis) {
              main_ele_dis.innerHTML = theme.Currency.formatMoney(netcount, theme.settings.moneyFormat);
            }
            
              countprice = countprice + pricecount ;
              countnet = countnet + netcount ;
          });
      }
    if(countprice != 0){
      // console.log(total);
      if(cart_main_price)cart_main_price.innerHTML = `- ${theme.Currency.formatMoney(countprice, theme.settings.moneyFormat)}`;
      if(cart_comper_price)cart_comper_price.innerHTML = theme.Currency.formatMoney(countnet, theme.settings.moneyFormat);
    }else{
      if(cart_main_price)cart_main_price.innerHTML = '';
      if(cart_comper_price)cart_comper_price.innerHTML = '';
    }
    if(cart_comper_price && total <= 1) cart_comper_price.innerHTML = '';
  return total;
}
  
}
customElements.define('quantity-input-mix-match', QuantityInputMax);

const popup_pen = document.querySelector('.mobile_view_pack_btn') || null; 
const popup_pen_else = document.querySelector('.bundle-add-to-cart') || null;
const popup_pen_else_content = document.querySelector('.bundle_right_top_part') || null;
const datacloseright = document.querySelector('[data-close-right]') || null;
if(popup_pen && popup_pen_else && popup_pen_else_content){
   popup_pen.addEventListener('click', (event) => {
     event.preventDefault();
          popup_pen_else.classList.toggle('active');
          popup_pen_else_content.classList.toggle('active');
          popup_pen.classList.toggle('active');
          document.body.classList.toggle('bundle_active');
      });
}

if(datacloseright && popup_pen_else && popup_pen_else_content){
   datacloseright.addEventListener('click', (event) => {
     event.preventDefault();
          popup_pen_else.classList.remove('active');
          popup_pen_else_content.classList.remove('active');
          popup_pen.classList.remove('active');
         document.body.classList.remove('bundle_active');
      });
}



// const addtocartbutton = document.querySelector('[data-added-bundle-on-cart]') || null;


// if(addtocartbutton){
//  addtocartbutton.addEventListener('click', (event) => {
//      event.preventDefault();
// // console.log("click");
//    const allcountbundleiteams = document.querySelectorAll("[data-gift-selector='true']") || null;
//    if(!allcountbundleiteams.length > 1) return;
  
//       let products = [];
// const time_stamp = Date.now();
//         allcountbundleiteams.forEach((b ,index) => {
//                    let product = {};
//                         product.id = b.getAttribute('product-var-id');
//                         product.quantity = b.querySelector("input[name='quantity']").value;
//                          product.properties = {
//                               '_bundle': true,
//                               '_time':time_stamp
//                             }
//                       products.push(product);
//                 }); 
//                 const ADDTOCART_OBJECT = { items: products };
//    // console.log(ADDTOCART_OBJECT);
//           custom_addtocart_fun(ADDTOCART_OBJECT,true);
   
//     });  
// }



// function custom_addtocart_fun(product,open_drawer){
//       fetch(`${routes.cart_add_url}`,{ 
//               method: 'POST',
//               headers: { "Accept": "application/json", "Content-Type": "application/json" },
//               body: JSON.stringify(product)
//         })
//         .then(response => response.json()).then(response => {        
//         })
//         .catch((error) => {
//           console.error('Error:', error);
//         })
//         .finally((e) => {
//           if(open_drawer){

//             // const this_cartDrawer = document.querySelector('cart-drawer') || null;
//             // if(this_cartDrawer){
//             //   this_cartDrawer.refresh(true);
//             // }else{
//             //   window.location = window.routes.cart_url;
//             // }

//             const cart_drawer = document.querySelector("cart-drawer"); 
//              if(cart_drawer){
//                 cart_drawer?.open();
//              }

//           }else{
//               location.href = window.routes.cart_url;
//             }
//         });
// }


const addtocartbutton = document.querySelector('[data-added-bundle-on-cart]');

if (addtocartbutton) {
  addtocartbutton.addEventListener('click', (event) => {
    event.preventDefault();

    const bundleItems = document.querySelectorAll("[data-gift-selector='true']");
    if (bundleItems.length === 0) return;

    const items = [];
    const timeStamp = Date.now();

    bundleItems.forEach((el) => {
      items.push({
        id: el.getAttribute("product-var-id"),
        quantity: el.querySelector("input[name='quantity']").value,
        properties: {
          "_bundle": true,
          "_time": timeStamp
        }
      });
    });

    addBundleToCart(items,true);
  });
}

async function addBundleToCart(items, open_drawer) {
  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];

  const formData = new FormData();

  // Add bundle line items
  items.forEach((item, i) => {
    formData.append(`items[${i}][id]`, item.id);
    formData.append(`items[${i}][quantity]`, item.quantity);

    for (const key in item.properties) {
      formData.append(`items[${i}][properties][${key}]`, item.properties[key]);
    }
  });

  // Cart drawer instance
  const drawer = document.querySelector("cart-drawer");

  if (drawer && drawer.getSectionsToRender) {
    formData.append(
      "sections",
      drawer.getSectionsToRender().map((s) => s.section)
    );
    formData.append("sections_url", window.location.pathname);
  }

  config.body = formData;

  let response;

  try {
    response = await fetch(`${routes.cart_add_url}`, config).then((r) =>
      r.json()
    );

    if (response.errors) {
      console.error(response.errors);
      return;
    }

    if (open_drawer) {
        // Update drawer HTML
        if (drawer && drawer.renderContents) {
          drawer.renderContents(response);
        }

        // Update header counters
        if (typeof updateCartCounters === "function") {
          updateCartCounters();
        }

        // Open drawer AFTER updating content
        drawer?.open();
    } else {
          window.location.href = window.routes.cart_url;
    }
  } catch (err) {
    console.error(err);
  }
}




theme.Currency = (function() {
    var moneyFormat = '€{{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = window.cartStrings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
  
    wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
  
    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },
  
    throttle: function(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },
  
    prepareTransition: function(el, callback) {
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }
  
      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering
  
      if (typeof callback === 'function') {
        callback();
      }
    },
  
    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    serialize: function(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };


class VariantMixBunbdle extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach(
      (input) => input.addEventListener('input', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = event.target.value;
    const previousvariantitle = event.target.getAttribute('data-variant-title');
    const previousvarianprice = event.target.getAttribute('data-variant-price');
    this.main_wapper = event.target.closest('[data-mix-match-bundle-main-items]') || null;
    if(!this.main_wapper) return;
     this.vsrint_data_selector  = this.main_wapper.querySelector('quantity-input-mix-match') || null;
    if(!this.vsrint_data_selector) return; 
        this.vsrint_data_selector.setAttribute('product-var-id',previousValue);
       this.vsrint_data_selector.setAttribute('product-variant',previousvariantitle);
       this.vsrint_data_selector.setAttribute('product-price',previousvarianprice);
  } 
}

customElements.define('variant-mix-match-variant', VariantMixBunbdle);
